export default "/images/visa.png";